module.exports = __webpack_public_path__ + "d781a4a68dc12480aa121bea7510cf66.fbx";